import createSvgIcon from 'apollo-react-icons/createSvgIcon';
import React from 'react';

const RepositoryIcon = createSvgIcon(
  <g>
    <path
      d="M21.5,4.25 C21.6380712,4.25 21.75,4.13807119 21.7499997,4 L21.75,3.25 C21.75,2.83578644 21.4142136,2.5 21,2.5 L8,2.5 L7.82,2.424 L6.478,1.035 C6.1479954,0.693081906 5.69319577,0.499972538 5.218,0.5 L2.286,0.5 C1.16177688,0.500551766 0.250551766,1.41177688 0.25,2.536 L0.25,15.25 C0.249734509,15.7142102 0.434023723,16.1594838 0.762269954,16.48773 C1.09051618,16.8159763 1.5357898,17.0002655 2,17 L2.24999971,17 C2.38807119,17 2.5,16.8880712 2.5,16.75 L2.5,7.25 C2.5,5.59314575 3.84314575,4.25 5.5,4.25 L21.5,4.25 Z"
      id="Path"
    ></path>
    <path
      d="M22,6 L6,6 C5.03395859,6.00110216 4.25110216,6.78395859 4.25,7.75 L4.25,19.75 C4.25110216,20.7160414 5.03395859,21.4988978 6,21.5 L22,21.5 C22.9660414,21.4988978 23.7488978,20.7160414 23.75,19.75 L23.75,7.75 C23.7488978,6.78395859 22.9660414,6.00110216 22,6 Z"
      id="Shape"
    ></path>
  </g>,
  'Repository'
);

export default RepositoryIcon;
